module.exports = __webpack_public_path__ + "media/images/lp/fig_guide_01-44c887b96f4ae958ea9aea6f7757d98d.png";